export function exclusiveRighttoBuyListingContract2026() {
return [   // Release 2025-12-29 17:05:45
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Radiobutton BrokerRelationship Buyer Agency", 
   isText: false,
   type: "checkbox",
   top: 266.52,
   left: 168.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Radiobutton BrokerRelationship Transaction Brokerage", 
   isText: false,
   type: "checkbox",
   top: 265.56,
   left: 286.92,
   width: 11.28,
   height: 11.28
}
,
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 285.72,
   left: 474.6,
   width: 114.96,
   height: 13.92
}
,
{
   page: 0,
   name: "Radiobutton BrokerageFirmSize Multiple Person", 
   isText: false,
   type: "checkbox",
   top: 379.32,
   left: 77.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Radiobutton BrokerageFirmSize One Person", 
   isText: false,
   type: "checkbox",
   top: 439.8,
   left: 77.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Buyer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 491.04,
   left: 106.56,
   width: 470.52,
   height: 13.92
}
,
{
   page: 0,
   name: "Buyer Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 509.04,
   left: 149.52,
   width: 427.56,
   height: 13.92
}
,
{
   page: 0,
   name: "Buyer Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 526.8,
   left: 110.88,
   width: 466.20,
   height: 13.92
}
,
{
   page: 0,
   name: "Property Description", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 559.639,
   left: 48.4366,
   width: 543.3834,
   height: 97.927
}
,
{
   page: 0,
   name: "Checkbox Lease of Property", 
   isText: false,
   type: "checkbox",
   top: 709.08,
   left: 95.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Date Listing Begins", 
   fontSize: 9,
   type: "date",
   top: 41.04,
   left: 394.44,
   width: 90.00,
   height: 12.60
}
,
{
   page: 1,
   name: "Date Listing Ends", 
   fontSize: 9,
   type: "date",
   top: 67.728,
   left: 69.3821,
   width: 66.8719,
   height: 13.490
}
,
{
   page: 1,
   name: "TextDate Listing Ends", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 67.44,
   left: 139.484,
   width: 263.236,
   height: 13.91
}
,
{
   page: 1,
   name: "Radiobutton DeadlinesExtendedToNextBusinessDay Will", 
   isText: false,
   type: "checkbox",
   top: 213.72,
   left: 282.12,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Radiobutton DeadlinesExtendedToNextBusinessDay Will Not", 
   isText: false,
   type: "checkbox",
   top: 213.72,
   left: 328.68,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Checkbox Buyer Agency Only", 
   isText: false,
   type: "checkbox",
   top: 433.08,
   left: 108.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Checkbox Success Fee", 
   isText: false,
   type: "checkbox",
   top: 321.24,
   left: 99.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Percent Sale Compensation", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 335.04,
   left: 208.92,
   width: 45.00,
   height: 12.36
}
,
{
   page: 2,
   name: "Amount Sale Compensation", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 335.04,
   left: 374.16,
   width: 80.04,
   height: 12.36
}
,
{
   page: 2,
   name: "Checkbox SaleCompensationAdjustedAmount See Additional Provisions", 
   isText: false,
   type: "checkbox",
   top: 366.84,
   left: 77.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Checkbox SaleCompensationAdjustedAmount Other", 
   isText: false,
   type: "checkbox",
   top: 380.947,
   left: 77.2367,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 2,
   name: "SaleCompensationAdjustedAmount Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 377.52,
   left: 129.24,
   width: 455.76,
   height: 12.36
}
,
{
   page: 2,
   name: "Checkbox Hourly Fee", 
   isText: false,
   type: "checkbox",
   top: 457.495,
   left: 95.16,
   width: 10.08,
   height: 9.425
}
,
{
   page: 2,
   name: "Amount Hourly Fee", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 454.32,
   left: 296.76,
   width: 60.00,
   height: 12.36
}
,
{
   page: 2,
   name: "Amount Max Hourly Fee", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 467.52,
   left: 262.92,
   width: 65.04,
   height: 12.36
}
,
{
   page: 2,
   name: "Checkbox Retainer Fee", 
   isText: false,
   type: "checkbox",
   top: 499.56,
   left: 95.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Amount Retainer Fee", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 497.04,
   left: 446.52,
   width: 75.00,
   height: 12.36
}
,
{
   page: 2,
   name: "Radiobutton RetainerFeeCreditedAgainstOtherFees Will", 
   isText: false,
   type: "checkbox",
   top: 512.52,
   left: 316.68,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Radiobutton RetainerFeeCreditedAgainstOtherFees Will Not", 
   isText: false,
   type: "checkbox",
   top: 512.52,
   left: 367.8,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Checkbox Other Compensation", 
   isText: false,
   type: "checkbox",
   top: 542.04,
   left: 95.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Other Compensation", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 539.64,
   left: 210.72,
   width: 369.96,
   height: 12.36
}
,
{
   page: 2,
   name: "Amount Lease Dollars", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 579.84,
   left: 148.56,
   width: 90.00,
   height: 12.36
}
,
{
   page: 2,
   name: "Per square", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 579.84,
   left: 287.4,
   width: 150.0,
   height: 12.36
}
,
{
   page: 2,
   name: "Amount Lease or", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 593.04,
   left: 78.36,
   width: 354.96,
   height: 10.92
}
,
{
   page: 2,
   name: "Checkbox Lease Adjusted Amount See Additional Provisions", 
   isText: false,
   type: "checkbox",
   top: 608.52,
   left: 182.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Checkbox Lease Adjusted Amount Other", 
   isText: false,
   type: "checkbox",
   top: 608.52,
   left: 354.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Lease Adjusted Amount Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 606,
   left: 397.32,
   width: 180.00,
   height: 12.36
}
,
{
   page: 2,
   name: "Lease Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 620.52,
   left: 129.6,
   width: 447.48,
   height: 12.36
}
,
{
   page: 2,
   name: "Lease When Earned", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 661.44,
   left: 67.56,
   width: 474.96,
   height: 12.36
}
,
{
   page: 2,
   name: "Radiobutton Lease BrokerageFirmPaid Will", 
   isText: false,
   type: "checkbox",
   top: 690.36,
   left: 450.12,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Radiobutton Lease BrokerageFirmPaid Will Not", 
   isText: false,
   type: "checkbox",
   top: 690.36,
   left: 501.24,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Lease Payment as follows", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 727.68,
   left: 67.56,
   width: 515.04,
   height: 12.36
}
,
{
   page: 3,
   name: "Radiobutton WhoPaysBrokerageFirm Seller May Pay Buyer Is Obligated To Pay", 
   isText: false,
   type: "checkbox",
   top: 57.96,
   left: 99.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "Radiobutton WhoPaysBrokerageFirm Buyer Will Pay", 
   isText: false,
   type: "checkbox",
   top: 107.346,
   left: 99.4913,
   width: 10.0797,
   height: 10.735
}
,
{
   page: 3,
   name: "Holdover Period Number Calendar Days", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 169.92,
   left: 539.52,
   width: 50.04,
   height: 11.64
}
,
{
   page: 3,
   name: "Radiobutton HoldoverBuyerOwes Will", 
   isText: false,
   type: "checkbox",
   top: 209.64,
   left: 91.8,
   width: 10.735,
   height: 10.08
}
,
{
   page: 3,
   name: "Radiobutton HoldoverBuyerOwes Will Not", 
   isText: false,
   type: "checkbox",
   top: 210.11,
   left: 147.928,
   width: 10.080,
   height: 10.08
}
,
{
   page: 3,
   name: "Radiobutton AgreementWithOtherBroker Is", 
   isText: false,
   type: "checkbox",
   top: 339.24,
   left: 266.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "Radiobutton AgreementWithOtherBroker Is Not", 
   isText: false,
   type: "checkbox",
   top: 339.24,
   left: 303,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "Radiobutton ReceivedListOfSubmittedProperty Has", 
   isText: false,
   type: "checkbox",
   top: 362.28,
   left: 50.52,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "Radiobutton ReceivedListOfSubmittedProperty Has Not", 
   isText: false,
   type: "checkbox",
   top: 362.28,
   left: 99,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "Brokerage Services", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 691.203,
   left: 50.4002,
   width: 542.0748,
   height: 73.0548
}
,
{
   page: 4,
   name: "Showing Properties limitations", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 67.96,
   left: 261.12,
   width: 320.04,
   height: 11.88
}
,
{
   page: 4,
   name: "Showing Properties MLS", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 91.637,
   left: 58.9093,
   width: 520.4747,
   height: 12.836
}
,
{
   page: 4,
   name: "Radiobutton GrantDisclosureBuyersIdentity Does", 
   isText: false,
   type: "checkbox",
   top: 112.92,
   left: 292.2,
   width: 10.08,
   height: 10.08
}
,
{
   page: 4,
   name: "Radiobutton GrantDisclosureBuyersIdentity Does Not", 
   isText: false,
   type: "checkbox",
   top: 112.92,
   left: 343.32,
   width: 10.08,
   height: 10.08
}
,
{
   page: 4,
   name: "Additional Provisions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 561.602,
   left: 39.2729,
   width: 556.4741,
   height: 202.0013
}
,
{
   page: 5,
   name: "ChecklistItem Attachments", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 54.982,
   left: 39.9274,
   width: 550.5836,
   height: 59.964
}
,
{
   page: 5,
   name: "Electronic Notice", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 216.24,
   left: 211.32,
   width: 369.96,
   height: 10.68
}
,
{
   page: 5,
   name: "Buyer 1 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 496.44,
   left: 103.92,
   width: 469.68,
   height: 14.16
}
,
{
   page: 5,
   name: "Buyer 1 Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 534.36,
   left: 112.56,
   width: 465.00,
   height: 14.16
}
,
{
   page: 5,
   name: "Buyer 1 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 549.24,
   left: 112.56,
   width: 170.04,
   height: 14.16
}
,
{
   page: 5,
   name: "Buyer 1 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 549.24,
   left: 407.04,
   width: 169.92,
   height: 14.16
}
,
{
   page: 5,
   name: "Buyer 1 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 564.24,
   left: 112.56,
   width: 465.00,
   height: 14.04
}
,
{
   page: 5,
   name: "Buyer 2 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 587.16,
   left: 103.92,
   width: 469.68,
   height: 14.16
}
,
{
   page: 5,
   name: "Buyer 2 Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 625.2,
   left: 112.56,
   width: 465.00,
   height: 14.04
}
,
{
   page: 5,
   name: "Buyer 2 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 640.2,
   left: 112.56,
   width: 170.04,
   height: 14.16
}
,
{
   page: 5,
   name: "Buyer 2 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 640.2,
   left: 407.04,
   width: 169.92,
   height: 14.16
}
,
{
   page: 5,
   name: "Buyer 2 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 655.2,
   left: 112.56,
   width: 465.00,
   height: 14.04
}
,
{
   page: 5,
   name: "Buyer 3 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 678.12,
   left: 103.92,
   width: 469.68,
   height: 14.16
}
,
{
   page: 5,
   name: "Buyer 4 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 720.12,
   left: 103.92,
   width: 469.68,
   height: 14.16
}
,
{
   page: 6,
   name: "Buyer Brokerage Firm Name 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 54.328,
   left: 115.201,
   width: 462.219,
   height: 12.836
}
,
{
   page: 6,
   name: "Buyer Broker Name 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 69.72,
   left: 129,
   width: 349.8,
   height: 12.72
}
,
{
   page: 6,
   name: "Signature Buyer Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 89.019,
   left: 135.492,
   width: 342.437,
   height: 12.836
}
,
{
   page: 6,
   name: "Date Signature Buyer Broker", 
   fontSize: 9,
   type: "date",
   top: 108.12,
   left: 81.6,
   width: 175.08,
   height: 12.72
}
,
{
   page: 6,
   name: "Buyer Brokerage Address Street", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 136.92,
   left: 220.56,
   width: 349.92,
   height: 12.72
}
,
{
   page: 6,
   name: "Buyer Brokerage Address City State Zip", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 154.065,
   left: 220.56,
   width: 349.92,
   height: 12.720
}
,
{
   page: 6,
   name: "Buyer Broker Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 176.32,
   left: 189.0,
   width: 350.04,
   height: 12.72
}
,
{
   page: 6,
   name: "Buyer Broker Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 189.76,
   left: 189.0,
   width: 350.04,
   height: 12.72
}
,
{
   page: 6,
   name: "Buyer Broker Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 203.44,
   left: 189.0,
   width: 350.04,
   height: 12.72
}
,
{
   page: 6,
   name: "Buyer CoAgent Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 238.135,
   left: 144.0,
   width: 349.8,
   height: 12.720
}
,
{
   page: 6,
   name: "Signature Buyer CoAgent", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 257.583,
   left: 151.201,
   width: 343.091,
   height: 11.527
}
,
{
   page: 6,
   name: "Date Signature Buyer CoAgent", 
   fontSize: 9,
   type: "date",
   top: 275.88,
   left: 81.6,
   width: 175.08,
   height: 12.72
}
] }
